import React, { useContext, useState, useEffect, useCallback } from "react";
import Header from "../../components/template/estimate/Header";
import OldHouseDetails from "../../components/PropertyInfo/OldHouseDetails";
import NewHouseDetails from "../../components/PropertyInfo/NewHouseDetails";
import forwardDirection from "../../assets/images/estimate/next.png";
import MovePlannerContext from "../../context/move_planner/movePlanner";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  thunkSubmitPropertyInfoForm,
  thunkLoadPropertyInfoFromSession,
} from "../../redux/reducers/property_info/propertyInfoReducer";
import {
  thunkLoadMoveInfoFromSession,
  thunkUpdateMoveInfoFromURL,
} from "../../redux/reducers/move_info/moveInfoReducer";
import ProgressBar from "../../components/template/ProgressBar";
import navigationsLinks from "../../constants/navigation_links";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { HouseDetailsSkeleton } from "../../components/skeleton/estimate/propertyInfo";
import config from "../../config/config";
export default function PropertyInfo(props) {
  const context = useContext(MovePlannerContext);
  const history = useHistory();
  const dispatch = useDispatch();
  const { handleSubmit: propertyInfoSubmit } =
    context.estimateForm.usePropertyInfoForm;
  //redux state
  const propertyInfo = useSelector((state) => state.propertyInfo);
  const moveInfoState = useSelector((state) => state.moveInfo);
  //old house state
  const [oldDistanceUnit, setOldDistanceUnit] = useState(
    propertyInfo.oldHouseDistanceUnit
  );
  const [oldHasElevator, setOldHasElevator] = useState(
    propertyInfo.oldHouseHasElevator
  );
  const [newDistanceUnit, setNewDistanceUnit] = useState(
    propertyInfo.newHouseDistanceUnit
  );
  const [newHasElevator, setNewHasElevator] = useState(
    propertyInfo.newHouseHasElevator
  );
  // const [isLoading, setIsLoading] = useState(false);
  const isLoading = moveInfoState.isMoveInfoFormSubmitting;

  const handleFormSubmit = async (data, event) => {
    data["old_house_elevator_available"] = oldHasElevator;
    data["old_house_distance_unit"] = oldDistanceUnit;
    data["new_house_elevator_available"] = newHasElevator;
    data["new_house_distance_unit"] = newDistanceUnit;
    let gotoPage = undefined;
    if (event !== undefined) {
      gotoPage = event.gotoPage;
    }
    dispatch(
      thunkSubmitPropertyInfoForm({ data, history, gotoPage: gotoPage })
    );

    // dispatch(updatePropertyInfoState(data));
    // console.log("store update to", propertyInfo);
  };
  const loadMoveInfoFromSession = useCallback(() => {
    if (
      moveInfoState.hasLoadedFromSession === false &&
      sessionStorage.getItem("move_info") !== null
    ) {
      const data = sessionStorage.getItem("move_info");
      dispatch(thunkLoadMoveInfoFromSession({ moveInfo: data }));
    }
  }, [dispatch, moveInfoState.hasLoadedFromSession]);
  useEffect(() => {
    if (
      propertyInfo.hasLoadedFromSession === false &&
      sessionStorage.getItem("property_info") !== null
    ) {
      const data = sessionStorage.getItem("property_info");
      dispatch(thunkLoadPropertyInfoFromSession({ propertyInfo: data }));
      loadMoveInfoFromSession();
    }
    if (sessionStorage.getItem("property_info") === null) {
      loadMoveInfoFromSession();
    }
  }, [dispatch, loadMoveInfoFromSession, propertyInfo.hasLoadedFromSession]);

  useEffect(() => {
    try {
      //TODO: validate date check and type for each params.
      // const url = new URL(window.location.href);
      let param = new URLSearchParams(window.location.search);

      //link signature
      // w and b from within and between city
      // flexible 1 or 0
      // /packers-and-movers-relocation-services/get-quote?
      // pTsize=1 BHK&city=bangalore&from=koramangal, karnataka, bangalore&to=ejipura&mvOn=2020-11-20 10:10:10&mvType=w&flexible=1
      if (
        param.get("pTsize") !== null &&
        param.get("from") !== null &&
        param.get("to") !== null &&
        param.get("mvOn") !== null &&
        param.get("mvType") !== null &&
        param.get("city") !== null &&
        param.get("flexible") !== null
      ) {
        // setIsLoading(true);
        const propertySize = param.get("pTsize");
        const movingFrom = param.get("from");
        const movingTo = param.get("to");
        const movingOn = param.get("mvOn");
        const moveType =
          param.get("mvType") === "w" ? "Within City" : "Inter City";
        const selectCity = param.get("city");
        const isFlexible = param.get("flexible");

        dispatch(
          thunkUpdateMoveInfoFromURL({
            propertySize,
            movingFrom,
            movingTo,
            movingOn,
            moveType,
            selectCity,
            isFlexible,
          })
        );
        // setIsLoading(false);
      }
    } catch (e) {
      console.error(e);
    }
  }, [dispatch]);

  const JSX = (
    <React.Fragment>
      <Header
        currentPage="propertyInfo"
        referenceToSubmit={(params) =>
          propertyInfoSubmit(handleFormSubmit)(params)
        }
      />
      <main className="container">
        <section className="progress-bar-section">
          <div className="row align-items-center justify-content-center">
            <div className="col-sm-12 col-md-12 col-lg-9">
              <ProgressBar
                currentPage="propertyInfo"
                referenceToSubmit={(params) =>
                  propertyInfoSubmit(handleFormSubmit)(params)
                }
              />
            </div>
          </div>
        </section>
        <div className="property-info-container">
          <form
            name="property_info_form"
            id="estimatePropertyInfo"
            method="POST"
            noValidate={true}
            onSubmit={propertyInfoSubmit(handleFormSubmit)}
            autoComplete="off"
          >
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                {isLoading === true && <HouseDetailsSkeleton />}
                {isLoading === false && (
                  <OldHouseDetails
                    distanceUnit={{ oldDistanceUnit, setOldDistanceUnit }}
                    elevatorInfo={{ oldHasElevator, setOldHasElevator }}
                  />
                )}
              </div>
              <div className="col-sm-12 col-md-2">
                <div className="summary-container position-relative">
                  <div
                    className="direction"
                    style={{ position: "absolute", top: "6rem", left: "4rem" }}
                  >
                    <img src={forwardDirection} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                {isLoading === true && <HouseDetailsSkeleton />}
                {isLoading === false && (
                  <NewHouseDetails
                    distanceUnit={{ newDistanceUnit, setNewDistanceUnit }}
                    elevatorInfo={{ newHasElevator, setNewHasElevator }}
                  />
                )}
              </div>
            </div>
            <div className="row">
            <div class="col-sm-12">
            <div className="helpful-tips helpful-tips-1">
              <img
                src={config.customerPortal + "assets/images/icons/lift.png"}
                alt="..."
                className="img-fluid"
                width="40"
              />
              If your building has a working service lift, it will reduce the
              overall quote value.
            </div>
            <div className="helpful-tips">
              <img
                src={config.customerPortal + "assets/images/icons/courier.png"}
                alt="..."
                className="img-fluid"
                width="40"
              />
              If Distance between Truck Parking to Service Lift is less than 50
              Meters, it will reduce the overall quote value.
            </div>
          </div>
            </div>
            <div className="row house-navigate-container">
              <div className="col-12 text-center my-5">
                <button
                  type="button"
                  className="btn btn-sm btn-dark bottom-nav mr-2"
                  onClick={() => {
                    propertyInfoSubmit(handleFormSubmit)({
                      gotoPage: navigationsLinks.move_details_page,
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faChevronLeft} /> Move details
                </button>
                <button type="submit" className="btn btn-sm">
                  Inventory <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </React.Fragment>
  );
  return JSX;
}
